import DoubleBlackField from '@/public/assets/images/double/double-black-field.png'
import DoubleRedField from '@/public/assets/images/double/double-red-field.png'
import DoubleGreenField from '@/public/assets/images/double/double-green-field.png'

import { Flex } from '@chakra-ui/react'
import { ReactElement } from 'react'
import { DoubleColor } from '@/__generated__/graphql'

export const DoubleField = ({
  type,
  boxSize = 24,
  isDisabled,
  isHighlighted = false,
}: {
  type: DoubleColor
  boxSize?: number
  isDisabled?: boolean
  isHighlighted?: boolean
}) => {
  return (
    <Flex
      justifyContent={'center'}
      alignItems={'center'}
      boxSize={boxSize}
      rounded={boxSize > 10 ? '2xl' : 'md'}
      opacity={isHighlighted ? 1 : isDisabled ? 0.4 : 1}
      transitionDuration={'.2s'}
    >
      {fieldImages[type]}
    </Flex>
  )
}

const fieldImages: Record<DoubleColor, ReactElement> = {
  [DoubleColor.Black]: <img src={DoubleBlackField.src} alt={''} />,
  [DoubleColor.Red]: <img src={DoubleRedField.src} alt={''} />,
  [DoubleColor.Green]: <img src={DoubleGreenField.src} alt={''} />,
}
